import { getAsset } from "../../services/assetStore";


let doprint = false;
// let doprint = true;


function parseTimeToSeconds(value) {
  if (value === undefined || value === null) return 0;

  const text = String(value).trim();

  if (/^\d+(\.\d+)?$/.test(text)) {
    return Number(text);
  }

  const parts = text.split(":").map(Number);

  if (parts.length === 3) {
    return (parts[0] * 3600) + (parts[1] * 60) + parts[2];
  }

  if (parts.length === 2) {
    return (parts[0] * 60) + parts[1];
  }

  return 0;
}

/*
function parseLyricsText(text) {
  if (!text) return [];

  try {
    const json = JSON.parse(text);

    if (Array.isArray(json)) {
      return json.map((line, index) => ({
        time: parseTimeToSeconds(line.time ?? line.start ?? line.startTime ?? index),
        text: line.text ?? line.lyric ?? line.words ?? "",
      }));
    }
  } catch (e) {
    // not JSON
  }

  const lrcLines = text
    .split(/\r?\n/)
    .map((line) => {
      const match = line.match(/^\[(\d+:\d+(?:\.\d+)?)\]\s*(.*)$/);
      if (!match) return null;

      return {
        time: parseTimeToSeconds(match[1]),
        text: match[2],
      };
    })
    .filter(Boolean);

  if (lrcLines.length) {
    return lrcLines;
  }

  return text
    .split(/\r?\n/)
    .map((line, index) => ({
      time: index,
      text: line.trim(),
    }))
    .filter((line) => line.text);
}
*/

function parseLyricsText(text) {

	if (doprint) console.log('parseLyricsText p1 text = ', text);

  if (!text) return [];


/*
  try {
    const json = JSON.parse(text);

    if (Array.isArray(json)) {
      return json.map((line, index) => ({
        time: parseTimeToSeconds(line.time ?? line.start ?? line.startTime ?? index),
        text: line.text ?? line.lyric ?? line.words ?? "",
      }));
    }
  } catch (e) {
    // not JSON
  }
*/

  try {
    const json = JSON.parse(text);

	if (doprint) console.log('parseLyricsText p2 json = ', json);


    const jsonLyrics = Array.isArray(json)
      ? json
      : Array.isArray(json.lyrics)
        ? json.lyrics
        : [];


	if (doprint) console.log('parseLyricsText p3 jsonLyrics = ', jsonLyrics);


    if (jsonLyrics.length) {
      return jsonLyrics.map((line, index) => ({
        time: parseTimeToSeconds(line.time ?? line.start ?? line.startTime ?? index),
        text: line.text ?? line.lyric ?? line.words ?? "",
      }));
    }
  } catch (e) {

	console.log('parseLyricsText p4 not JSON e = ', e);

    // not JSON
  }


  try {
    const xml = new DOMParser().parseFromString(text, "text/xml");

    const parseError = xml.querySelector("parsererror");
    if (!parseError) {
      const nodes = Array.from(xml.querySelectorAll("lyrics > line, line"));

		if (doprint) console.log('parseLyricsText p5 nodes.length = ', nodes.length);
		if (doprint) console.log('parseLyricsText p5 nodes = ', nodes);


      if (nodes.length) {
        return nodes
          .map((node, index) => ({
            time: parseTimeToSeconds(node.getAttribute("time") ?? index),
            text: node.textContent.trim(),
          }))
          .filter((line) => line.text);
      }
    }
  } catch (e) {
	console.log('parseLyricsText p4 not XML e = ', e);
    // not XML
  }

  const lrcLines = text
    .split(/\r?\n/)
    .map((line) => {
      const match = line.match(/^\[(\d+:\d+(?:\.\d+)?)\]\s*(.*)$/);
      if (!match) return null;

      return {
        time: parseTimeToSeconds(match[1]),
        text: match[2],
      };
    })
    .filter(Boolean);

  if (lrcLines.length) {
    return lrcLines;
  }

  return text
    .split(/\r?\n/)
    .map((line, index) => ({
      time: index,
      text: line.trim(),
    }))
    .filter((line) => line.text);
}


export const fetchLyrics = async (lyricsUrl, onFetchProgress) => {
  try {
    const response = await getAsset(lyricsUrl, false, onFetchProgress);
    const text = new TextDecoder("utf-8").decode(new Uint8Array(response));

    return {
      lyrics: parseLyricsText(text),
    };
  } catch (e) {
    throw new Error("Issue fetching lyrics");
  }
};


